import { COMPONENTRESOURCES, WizBasePopUp, WizDatasource } from '@wizeoo/akm-component-lib';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { first, Observable } from 'rxjs';
import { VALUE_ESCAPE, WizFileUtils } from '@wizeoo/akm-core-lib';
import { AttachmentService } from '../../../../command/core/attachment/attachment.service';
import { ThumbData, ThumbRenderer } from './thumb.renderer';
import { clone } from 'lodash-es';

@Component({
  // swap sur les images
  selector: 'swap-pop',
  templateUrl: './swap.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwapPop extends WizBasePopUp implements AfterViewInit {

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
   
    if (event.key === VALUE_ESCAPE) {
      event.stopImmediatePropagation();
      event.preventDefault();
      this.hide();
    }
  } 

  public static width: string = '150px';
  public static height: string = '400px';
  
  public thumbRenderer: any = ThumbRenderer;

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef, private sanitizer: DomSanitizer) {
    super();
  }

  public thumbDS: WizDatasource<ThumbData> = new WizDatasource<ThumbData>()
  .setItemCodeField('blobId')
  .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
  .build();

  public doSaveFlag: boolean = true;
  public hasChange: boolean = false; // une modif sur la collection

  public getThumbs(): ThumbData[] {
    return this.datas;
  }

  public clonedThumbs: ThumbData[] = null;

  show(): void {
    super.show();
    this.clonedThumbs = [];

    let idx: number = 0;
    let c: ThumbData;
    this.getThumbs().forEach((t: ThumbData) => {
      c = clone(t);
      c.order = idx++;
      c.provider = this.thumbDS;
      this.clonedThumbs.push(c);
    });
    this.thumbDS.setSource(this.clonedThumbs);
  }

  /** Sauvegarde */
  public save(): void {
    this.callback(this.thumbDS);
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.hide();
  }



}
